import React, { PureComponent } from 'react';
import { enumHelper } from '../../../utils';
import ENUMS from '../../../enums';
import RseeDiscountDetails from '../modals/rseeDiscountDetails';
import styles from './styles.scss';

class ListItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedRseeDiscountDetailsId: -1
    };
  }

  convertStatusToBadge = status => {
    switch (status) {
      case ENUMS.RSEE_DISCOUNTS_STATUS.values.CONFIRMED:
        return 'badge-success';
      case ENUMS.RSEE_DISCOUNTS_STATUS.values.WAITING_CONFIRMATION:
        return 'badge-warning';
      default:
        return 'badge-info';
    }
  };

  closeRseeDiscountDetailsModal = () => {
    this.setState(() => ({
      rseeDiscountDetailsOpen: false
    }));
  };

  displayRseeDiscountDetailsModal = id => {
    this.setState({ rseeDiscountDetailsOpen: true, selectedRseeDiscountDetailsId: id });
  };

  render() {
    return (
      <>
        <tr>
          <td className="text-center">
            {(this.props.pageNumber - 1) * this.props.pageSize + this.props.ix + 1}
          </td>
          <td className="text-center">{this.props.cafeName}</td>
          <td className="text-center">{this.props.fromDate}</td>
          <td className="text-center">{this.props.toDate}</td>
          <td className="text-center">
            <span className={`badge ${this.convertStatusToBadge(this.props.status)} p-1`}>
              {enumHelper.convertEnumValueToTitle(ENUMS.RSEE_DISCOUNTS_STATUS.list, this.props.status)}
            </span>
          </td>
          <td className={styles.createdAtColValue}>{this.props.createdAt}</td>
          <td className="text-center">
            {this.props.status !== ENUMS.RSEE_DISCOUNTS_STATUS.values.CONFIRMED && (
              <button
                onClick={() => this.props.activateRseeDiscount(this.props.id)}
                className="btn btn-sm btn-success"
              >
                {locales('tables.activate')}
              </button>
            )}
          </td>
          <td title={locales('titles.rseeDiscountDetails')} className="text-center">
            <i
              onClick={() => this.displayRseeDiscountDetailsModal(this.props.id)}
              className="pointer far fa-info-circle"
            />
          </td>
        </tr>
        {this.state.rseeDiscountDetailsOpen && (
          <RseeDiscountDetails
            isOpen={this.state.rseeDiscountDetailsOpen}
            discountId={this.state.selectedRseeDiscountDetailsId}
            closeModal={this.closeRseeDiscountDetailsModal}
          />
        )}
      </>
    );
  }
}

export default ListItem;
